module.exports = __webpack_public_path__ + "static/media/temperature-half.2ddadab4.svg";